<wlm-page-wrapper>
  <ng-container page-top-buttons>
    <wlm-grid-buttons
      *ngIf="gridSettings"
      [(gridSettings)]="gridSettings"
      [grid]="grid"
      [gridName]="gridSettingKey"
    >
      <ng-template wlmGridButtonsThirdSlot let-isContainerCollapsed="isContainerCollapsed">
        <button
          wlmCollapsibleButton
          [disabled]="!selectedItems || selectedItems.length === 0"
          [showLabel]="isContainerCollapsed"
          (click)="onDeleteScenarios(selectedItems)"
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </ng-template>
    </wlm-grid-buttons>
  </ng-container>

  <ng-container page-content>
    <wlm-local-grid
      class="wtr-fx-flex-grow"
      *ngIf="gridSettings"
      [gridSettings]="gridSettings"
      [gridData]="scenarios"
      [(selectedItems)]="selectedItems"
    ></wlm-local-grid>
  </ng-container>
</wlm-page-wrapper>
